import { UseQueryOptions, useQuery } from 'react-query'
import { BrandProfileAnalysis } from 'types'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { fetchAnalysis } from './useCreateBrandProfileAnalysisSync'

export type Data = { brand_profile_analysis: BrandProfileAnalysis }

export interface Options extends UseQueryOptions<Data> {}

export interface Props {
  id: number
  brandProfileId: number
  signal?: AbortSignal
}

export const useBrandProfileAnalysis = ({ id, brandProfileId, signal }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data>(
    ['workspaces', workspaceId, 'brandProfileAnalyses', 'detail', id],
    () => fetchAnalysis({ id, brandProfileId, workspaceId, signal }),
    {
      refetchOnWindowFocus: false,
      staleTime: (options?.cacheTime || 0) * 0.5,
      ...options,
    },
  )
}
